<template>
  <v-card class="pa-4">
    <v-flex xs12 pb-4 v-if="err">
      <v-alert :value="true" type="error">{{err}}</v-alert>
    </v-flex>
    <p>{{$lang.labels.activationText}}</p>
    <v-layout row wrap justify-space-between>
      <v-btn flat @click="$emit('close')" class="mx-0">{{$lang.actions.no}}</v-btn>
      <v-btn color="primary" @click="activate()" class="mx-0">{{$lang.actions.yes}}</v-btn>
    </v-layout>
  </v-card>
</template>

<script>
  export default {
    props: ['data'],
    data: () => ({
      err: '',
      success: '',
    }),
    methods: {
      activate() {
        this.$http.post(`webshopresource/activate/${this.data}`)
          .then((res) => {
            if (res.body.status === 'Success') {
              this.$emit('close');
              return;
            }
            this.err = res.body.statusText;
          })
          .catch((err) => {
            this.err = err.body.statusText || err.body.message;
          });
      }
    }
  }
</script>


// WEBPACK FOOTER //
// WebshopActivationModal.vue?15a75110